module.exports = __webpack_public_path__ + "img/wooland_checkpoint.287ac7ed.jpg";